import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../_services/app.service';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Helpers } from '../../../helpers';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
@Injectable()
export class VehicleService {
      vehicleList: any[];
      ownerShipTypeList: any[];
      branchList: any[];
      vehicleConditionList: any[];
      vehicleBodyTypeList: any[];
      classOfVehicleList: any[];
      vehicleFuelUsedLlist: any[];
      axleTypeList: any[];
      vehicleTypeList: any[];
      vehicleStatusTypeList: any[];
      companyList: any[];
      timeIntervalTypeList: any[];
      vehicleInsuranceTypeList: any[];
      gasKitTypeList: any[];
      vehiclePermitTypeList: any[];
      tyresMasterPositionList: any[];
      reeferTypeList: any[];
      vehicleAccountTypeList: any[];
      constructor(private _appService: appService, private translate: TranslateService,
            private toastr: ToastrService, private datePipe: DatePipe, private modalService: NgbModal) { }

      getVehicleList(userId): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetById("VehicleMaster", "GetAssignedLocationList", userId).subscribe(
                              (response) => {

                                    if (response) {
                                          response.map(x => {
                                                x.name = x.Name;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.vehicleList = response;
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            })
      }

      getBranchList(): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .Get("VehicleMaster", "GetBranch",)
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.map(x => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.branchList = response;
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            });
      }

      getOwnerShipTypeList(): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetById("Common", "GetLookByCategoryName", "OwnerShipType",)
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.map(x => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.ownerShipTypeList = response;
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            });
      }

      getCompanyList(TenantId): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetById("User", "GetCompanyList", TenantId)
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.map(x => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.companyList = response;
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            });
      }

      getVehicleConditionList(): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetById("Common", "GetLookByCategoryName", "VehicleConditionType")
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.map(x => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.vehicleConditionList = response;
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            });
      }

      getVehicleBodyType(): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetById("Common", "GetLookByCategoryName", "VehicleBodyType")
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.map(x => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.vehicleBodyTypeList = response;
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            });
      }

      getUnassignTyreConditionDataList(UserId: any): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService.GetById("TyreAssgin", "ta_GetUnassignTyreConditionDataList", UserId)
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.map(x => {
                                                x.name = x.text;
                                                x.value = x.id;
                                          })
                                    }
                                    this.vehicleBodyTypeList = response;
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            });
      }

      getClassOfVehicle(): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetById("Common", "GetLookByCategoryName", "ClassOfVehicle")
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.map(x => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.classOfVehicleList = response;
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            });
      }

      getFuelUsedType(): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetById("Common", "GetLookByCategoryName", "VehicleFuelUsed")
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.map(x => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.vehicleFuelUsedLlist = response;
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            });
      }

      getAxleType(): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetById("Common", "GetLookByCategoryName", "AxleType")
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.map(x => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.axleTypeList = response;
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);
                              }
                        );
            });
      }

      GetVehicleType(): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .Get("VehicleMaster", "GetVehicleType")
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.map(x => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.vehicleTypeList = response;
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            });
      }

      GetVehicleStatusType(): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetById("Common", "GetLookByCategoryName", "VehicleStatusType")
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.map(x => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.vehicleStatusTypeList = response;
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);
                              }
                        );
            });
      }

      GetTimeIntervalType(): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetById("Common", "GetLookByCategoryName", "TimeIntervalType")
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.map(x => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.timeIntervalTypeList = response;
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);
                              }
                        );
            });
      }

      GetGasKitType(): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetById("Common", "GetLookByCategoryName", "GasKitType")
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.map(x => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.gasKitTypeList = response;
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            });
      }

      getVehiclePermitType(): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetById("Common", "GetLookByCategoryName", "VehiclePermitType")
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.map(x => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.vehiclePermitTypeList = response;
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            });
      }

      getTyresMasterPosition(): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetById("Common", "GetLookByCategoryName", "TyresMasterPosition")
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.map(x => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.tyresMasterPositionList = response;
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            });
      }

      getReeferType(): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetById("Common", "GetLookByCategoryName", "ReeferType")
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.map(x => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.reeferTypeList = response;
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            });
      }

      GetVehicleInsuranceType(): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetById("Common", "GetLookByCategoryName", "VehicleInsuranceType")
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.map(x => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.vehicleInsuranceTypeList = response;
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            });
      }

      getDriverList(param, CompanyId, pageNo): Promise<any> {

            return new Promise((resolve, reject) => {
                  this._appService
                        .GetByQueryPageByCompanyId("VehicleMaster", "GetDriverList", param, pageNo, CompanyId)
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.Results.map(x => {
                                                x.name = x.text;
                                                x.value = x.id;
                                          })
                                    }
                                    resolve(response);
                                    return response;
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            })
      }

      getExpenseAccountList(param, CompanyId): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetByTwoId(
                              "ChartsofAccount",
                              "GetAccountTypeListforExpense",
                              CompanyId,
                              param
                        ).subscribe(
                              (response) => {

                                    if (response) {
                                          response.map(x => {
                                                x.name = x.AccountNumber;
                                                x.value = x.Id;
                                          })
                                    }
                                    resolve(response);
                                    return response;
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            })
      }

      getAccountLedger(param, Id): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetByTwoId("VehicleMaster", "vmd_GetVehicleExpenseCardAccount", Id, param)
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.map(x => {
                                                x.name = x.text;
                                                x.value = x.id;
                                          })
                                    }
                                    resolve(response);
                                    return response;
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            })
      }

      getTyreNoForTyreAssiged(param): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetByQueryPage("Tyres", "TyreNoForTyreAssiged", param, 1)
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.Results.map(x => {
                                                x.name = x.text;
                                                x.value = x.id;
                                          })
                                    }
                                    resolve(response.Results);
                                    return response.Results;
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            })
      }

      getAccountManagerList(param, CompanyId): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetByQueryPageByCompanyId("DriverMaster", "GetSelect2UserList", param, 1, CompanyId)
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.Results.map(x => {
                                                x.name = x.text;
                                                x.value = x.id;
                                          })
                                    }
                                    resolve(response.Results);
                                    return response.Results;
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            })
      }

      getAccountTypeforVehicle(param): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetByQueryPage("ChartsofAccount", "GetAccountListforVehicle", param, 1)
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.Results.map(x => {
                                                x.name = x.text;
                                                x.value = x.id;
                                          })
                                    }
                                    this.vehicleAccountTypeList = response.Results;
                                    resolve(response.Results);
                                    return response.Results;
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);
                              }
                        );
            })
      }

      deleteVehicleDetailsById(Id): Promise<any> {
            return new Promise((resolve) => {
                  const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
                  dialogRef.componentInstance.details = {
                        message: this.translate.instant("VehicleDetailsById.Areyousure"),
                        title: 'Warning',
                  }

                  dialogRef.componentInstance.close.subscribe((confirmed: boolean) => {
                        if (confirmed) {
                              Helpers.setLoading(true);
                              this._appService.Delete("VehicleMaster", "DeleteAllData", Id).subscribe(response => {
                                    let resSTR = JSON.stringify(response);
                                    let resJSON = JSON.parse(resSTR);

                                    if (resJSON._body == 2) {
                                          this.toastr.warning("Can't delete because transactions exist in booking");
                                    } else if (resJSON._body == 3) {
                                          this.toastr.warning("Can't delete because transactions exist in Reminders");
                                    } else {
                                          this.toastr.success("Detail Deleted Successfully!", "Success");
                                          resolve(1);
                                    }

                                    Helpers.setLoading(false);
                              }, err => {
                                    Helpers.setLoading(false);
                                    this.toastr.error("An error occurred while deleting data!", 'error');
                              });
                        }
                        dialogRef.close();
                  });
            });
      }

      getLookupByCategory(categoryName: any): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetById("Common", "GetLookByCategoryName", categoryName)
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.map(x => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.classOfVehicleList = response;
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching data !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            });
      }

      GetAccountListforNetwork(query, page): Promise<any> {

            return new Promise((resolve, reject) => {
                  this._appService
                        .GetByQueryPage("ChartsofAccount", "GetAccountListforNetwork", query, page)
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.Results.map(x => {
                                                x.name = x.text;
                                                x.value = x.id;
                                          })
                                    }
                                    resolve(response);
                                    return response;
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            })
      }
      GetsalespersonforNetwork(query, page): Promise<any> {

            return new Promise((resolve, reject) => {
                  this._appService
                        .GetByQueryPage("ChartsofAccount", "GetsalespersonNetwork", query, page)
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.Results.map(x => {
                                                x.name = x.text;
                                                x.value = x.id;
                                          })
                                    }
                                    resolve(response);
                                    return response;
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            })
      }
      getWarehouseCustomerList(param, param1, param2): Promise<any> {

            return new Promise((resolve, reject) => {
                  this._appService
                        .GetByThreeId("Network", "NewGetNetworkbyOwnership", param, param1, param2)
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.map(x => {
                                                x.name = x.text;
                                                x.value = x.id;
                                                delete x.text;
                                                delete x.id;
                                          })
                                    }
                                    resolve(response);
                                    return response;
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            })
      }
      getBranchListNew(value): Promise<any> {

            return new Promise((resolve, reject) => {
                  this._appService
                        .GetByQuery("Company", "newGetBranchList", value)
                        .subscribe(
                              (response) => {

                                    console.log('Raw Response:', response);
                                    if (response) {
                                          response.map((x) => {
                                                x.name = x.text;
                                                x.value = x.value;
                                                delete x.text;
                                          });
                                          resolve(response);
                                    } else {
                                          console.warn('No Results found or invalid response structure.');
                                          resolve([]);
                                    }
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            })
      }

      GetSubCompanyList(networkId, value): Promise<any> {

            return new Promise((resolve, reject) => {
                  this._appService
                        .GetByTwoId("Company", "NewGetSubCompanyList", networkId, value)
                        .subscribe(
                              (response) => {

                                    console.log('Raw Response:', response);
                                    if (response) {
                                          response.map((x) => {
                                                x.name = x.text;
                                                x.value = x.value;
                                                delete x.text;
                                          });
                                          resolve(response);
                                    } else {
                                          console.warn('No Results found or invalid response structure.');
                                          resolve([]);
                                    }
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            })
      }

      sw_GetCompanyDataSelect2(TenantId): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetById("User", "sw_GetCompanyDataSelect2", TenantId)
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.map(x => {
                                                x.name = x.text;
                                                x.value = x.id;
                                          })
                                    }
                                    this.companyList = response;
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            });
      }
}